<nb-layout>
  <nb-layout-column>
  <div class="forbidden-page">
    <div class="forbidden">
      <img src="/assets/theme/Logo_ParkBase.png" alt="Logo Parkbase" width="225" height="50" />
      <h1>Forbidden</h1>
      <p>We're sorry, the page you requested cannot be accessed.</p>
    </div>
  </div>
  </nb-layout-column>
</nb-layout>
